// Fire-and-forget client helper. Posts telemetry events to the backend
// which writes them to Workers Analytics Engine. Uses keepalive so the
// request survives page navigation (eg. landing_view followed by nav to
// /app/connect).

import { withBase } from "./base-path";

export type ClientTelemetryEvent =
  | "landing_view"
  | "connect_clicked"
  | "property_selected"
  | "report_loaded"
  | "export_requested"
  | "utm_audit_completed"
  // M15 (handover item 5) — share-loop + digest-forward events. The
  // server accepts the last three without a session (share viewer +
  // forwarded-digest landings are anonymous).
  | "share_framing_used"
  | "share_button_clicked"
  | "share_recipient_tool_cta_clicked"
  | "digest_forward_clicked";

interface SendArgs {
  event: ClientTelemetryEvent;
  tags?: Record<string, string | undefined>;
  values?: Record<string, number>;
}

export function reportTelemetry({ event, tags, values }: SendArgs): void {
  if (typeof window === "undefined") return;
  try {
    void fetch(withBase("/api/telemetry"), {
      method: "POST",
      credentials: "same-origin",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ event, tags, values }),
      keepalive: true,
    }).catch(() => {
      // Silent — telemetry must never interrupt user flow.
    });
  } catch {
    // Older browsers may throw on keepalive; ignore.
  }
}
